<template>

    <!--地图容器-->
    <div>
      <div id="IndexPage" class="IndexPage" style="width:100%;float:left"  v-loading="loading"
        element-loading-text="拼命加载中"  element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"></div>

      <div id="mapDialog">
        <div id="indexMapLeft">
            <!-- <he-feng-weather></he-feng-weather> -->
            <div>
                <div class="indexTitle">
                    <span>日数据在线情况（{{factorStr}}）</span>
                    <span>{{ date }}</span>
                </div>
                <div class="unes_unoe">
                    <div  class="unes_we">
                        <div  class="une_text">正常</div>
                        <div  class="IEM_w col_1">{{ statusDataChoose.status1 }}</div>
                    </div>
                    <div  class="unes_we">
                        <div  class="une_text">超标</div>
                        <div  class="IEM_w col_2">{{ statusDataChoose.status2 }}</div>
                    </div>
                    <div  class="unes_we">
                        <div  class="une_text">无数据</div>
                        <div  class="IEM_w col_3">{{ statusDataChoose.status3 }}</div>
                    </div>
                </div>
                  <div class="unes_unoe">
                    <div  class="unes_we">
                        <div  class="une_text">达标率</div>
                        <div  class="IEM_w col_4" v-if="statusDataChoose.rate<85">{{ statusDataChoose.rate }}%</div>
                        <div  class="IEM_w col_1" v-else>{{ statusDataChoose.rate }}%</div>
                    </div>
                    <span>国家标准为85%</span>
                </div>
            </div>
            <div  class="indexdisSta">
                <div class="indexTitle">
                    <span>噪声分布统计</span>
                    <span>{{ date }}</span>
                </div>
                <index-bar-chart :yData="distributionStatisticsyData" :collapsed="collapsed"></index-bar-chart>
            </div>
            <div   class="indexhourData">
                <div class="indexTitle">
                    <span>小时数据在线情况</span>
                    <span>{{ date }}</span>
                </div>
                <index-gauge-chart :yData="hourRate" :collapsed="collapsed"></index-gauge-chart>
            </div>
        </div>
        <div id="indexMapRight">
            <div  class="indexdisSta">
                <div class="indexTitle">
                    <span>功能区站点达标率统计</span>
                    <span>{{ date }}</span>
                </div>
                <index-line-chart :rateStaticData="rateStaticData" :collapsed="collapsed"></index-line-chart>
            </div>
            <div  class="indexdisSta">
                <div class="indexTitle">
                    <span>审核情况</span>
                    <span>{{ date }}</span>
                </div>
                <index-pie-chart :rateReviewData="rateReviewData" :collapsed="collapsed"></index-pie-chart>
            </div>
            <div  class="indexdisSta">
                <div class="indexTitle">
                    <span>天数据展示</span>
                    <span>{{ date }}</span>
                </div>
                <el-table :data="devices" border style="width: 100%;overflow-x:hidden" size="mini" :height="tableHeight"  @row-dblclick="chooseMarker" >
                    <el-table-column  prop="projectName"  label="项目" > 
                        <template slot-scope="scope">
                            <span> {{ projectMap.get(scope.row.projectId) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="point"  label="点位"> </el-table-column>
                    <el-table-column  prop="name"  label="类型"></el-table-column>
                    <el-table-column  prop="n00004"  label="昼间"> </el-table-column>
                    <el-table-column  prop="n00005"  label="夜间"> </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="input-card " id="mapDataType">
            <div class="input-item">
                <button v-on:click="showDay($event)" class="btn selected">昼</button>
                <button v-on:click="showNight($event)" class="btn">夜</button>
                <button  type="button" class="el-button el-button--default el-button--mini is-circle showFormBtn"  @click="showForm" ><i class="el-icon-search"></i></button>
                <button  type="button" class="el-button el-button--danger el-button--mini is-circle hideFormBtn"  @click="hideForm" ><i class="el-icon-close"></i></button>
                <button  type="button" class="el-button el-button--default el-button--mini is-circle"  @click="refreshMap" ><i class="el-icon-refresh"></i></button>
            </div>
        </div>
        <div class="mapFun">
            <div class="cyedbs_name">
                <span>环境噪声限值</span>
            </div>
            <div class="cyedbs_size">
                <table  border="1" class="nbmrd_name">
                    <tr >
                        <td >功能区类型</td>
                        <td v-for="item in functionalAreaList" :key="item.id">{{item.name}}</td>
                    </tr>
                    <tr >
                        <td >昼间</td>
                        <td v-for="item in functionalAreaList" :key="item.id">{{item.day}}</td>
                    </tr>
                    <tr >
                        <td >夜间</td>
                        <td v-for="item in functionalAreaList" :key="item.id">{{item.night}}</td>
                    </tr>
                </table>
            </div>
        </div>
      </div>

      <div id="indexToggleBtn" v-on:click="showTable()"></div>

      <div id="indexForm">
        <el-form :inline="true" :model="filters" size="mini">
            <el-form-item label="项目名称">
                <el-cascader  :options="projectTree" :props="defaultProps" collapse-tags :show-all-levels="false" clearable filterable v-model="filters.projectId" style="width:350px" ></el-cascader>
            </el-form-item>
            <el-form-item label="功能区" >
                <el-select v-model="filters.functionalAreaId"  filterable>
                    <el-option
                        v-for="item in functionalAreaList"
                        :label="item.name"
                        :value="item.id" :key="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker v-model="date" type="date"  value-format="yyyy-MM-dd"> </el-date-picker>
            </el-form-item>
            <el-form-item>
                <my-button  @select-type="clickBtn" QueryButtonShow  ResetButtonShow></my-button>
            </el-form-item>
        </el-form>
    </div>

    <!--Form界面-->
    <el-dialog title="详情" :visible.sync="detailVisible" id="mapclickDialog">
       <div style="overflow: hidden;">
            <div style="float:left;width:48%" :key="1">
                <h3 style="margin-top: 0;">点位详情：</h3>
               <ul  id="realUl">
                    <li style='width:400px'>点位名称:{{chooseObj.point }}</li>
                   <li style='width:400px'>功能区类型:{{chooseObj.name }}</li>
                   <li style='width:200px'>经度: {{chooseObj.lnglat[0] }}</li>
                   <li style='width:200px'>纬度: {{chooseObj.lnglat[1] }}</li>
                   <li style='width:200px;' >昼间:
                     <span v-if="chooseObj.n00004>chooseObj.day" style='color: #daa520;' >{{chooseObj.n00004 }}</span>
                     <span v-else style='color: #228b22;' >{{chooseObj.n00004 }}</span>
                    dB</li>
                   <li style='width:200px'>昼间限值: {{chooseObj.day }}dB</li>
                   <li style='width:200px;' >夜间:
                     <span v-if="chooseObj.n00005>chooseObj.night" style='color: #daa520;' >{{chooseObj.n00005 }}</span>
                     <span v-else style='color: #228b22;' >{{chooseObj.n00005 }}</span>
                    dB</li>
                   <li style='width:200px'>夜间限值: {{chooseObj.night }}dB</li>
               </ul>
               <h3>图片：</h3>
                <div v-if="picCount==0" style="text-align: center;font-weight: bold;margin: 10px;">暂未上传图片</div>
                <el-image  v-else   style=" height: 550px"  :src="picUrl"   :preview-src-list="picUrlList"> </el-image>
            </div>
           <div style="float:left;width:50%" class="map">
                <h3  style="margin-top: 0;">
                    污染日历图：
                    <el-radio-group v-model="dayType" size="mini" @input="getDayData">
                        <el-radio-button label="n00004">昼</el-radio-button>
                        <el-radio-button label="n00005">夜</el-radio-button>
                    </el-radio-group>
                </h3>
                <div  style=" height: 450px" >
                    <el-calendar v-model="calendarvalue" >
                        <template  slot="dateCell"  slot-scope="{date, data}" >
                            <div class="Userdate"   v-if="mapData.get (data.day)!=undefined">
                                <div  class="index_cal"  :style="'color:#fff;background:'+mapData.get (data.day)">{{ data.day.split('-')[2]}}</div>
                            </div>
                            <div class="Userdate"   v-else >
                                <div  class="index_cal"  >{{ data.day.split('-')[2]}}</div>
                            </div>
                        </template>
                    </el-calendar>
                    <div class="unes_unoe" style="width:80%;margin:0 auto">
                        <div  class="unes_we">
                            <div  class="une_text">正常</div>
                            <div  class="IEM_w col_1">{{ dialogCal.status1 }}</div>
                        </div>
                        <div  class="unes_we">
                            <div  class="une_text">超标</div>
                            <div  class="IEM_w col_2">{{ dialogCal.status2 }}</div>
                        </div>
                        <div  class="unes_we">
                            <div  class="une_text">无数据</div>
                            <div  class="IEM_w col_3">{{ dialogCal.status3 }}</div>
                        </div>
                    </div>
                </div>
                <h3>24小时噪声趋势图（Leq）：</h3>
                <div  style=" height: 200px" id="trendChart" ></div>
            </div>
       </div>
    </el-dialog>
  </div>
  </template>
  <script>
      import { getDevicePic,selectHourDataList,selectDayDataList,getComplianceRate,selectNoiseCalendar,selectNoiseTrend,getProjects } from '../../api/api';
      import {formatDate,formatDateDay,translateDataToTreeProject} from '../../../static/fun.js';
     
      import HeFengWeather from '../../components/Weather/HeFengWeather.vue'
      import IndexBarChart from '../../components/IndexPage/IndexBarChart.vue'
      import IndexGaugeChart from '../../components/IndexPage/IndexGaugeChart.vue'
      import IndexLineChart from '../../components/IndexPage/IndexLineChart.vue'
      import IndexPieChart from '../../components/IndexPage/IndexPieChart.vue'

      import myButton from '../../components/myButton/index.vue'

      import * as echarts from "echarts";

        export default {
            props: {
                collapsed: {
                    type: Boolean,
                },
            },
            components: { HeFengWeather,IndexBarChart,IndexGaugeChart,IndexLineChart,IndexPieChart,myButton},
          data () {
              return {
                    filters:{
                        functionalAreaId:'',
                        projectId:''
                    },
                    drawer: false,
                    projects:[],
                  devices:[],
                  date:'2023-05-23',
  
                  map:null,
                  count:0,
                  loading:false,
                  tableShow:true,
  
                  factor:"n00004",
                  factorStr:"昼间",
  
                  center:[],
                  projectMap:new Map(),
                  functionalAreaList:[],
                  firstFlag:true,
                  statusMap:new Map(),
                  statusData:{},
                  statusDataChoose:{},
                  distributionStatisticsyData:[],
                  hourRate:-1,
                  tableHeight:200,
                  rateStaticData:{},
                  rateReviewData:[],//顺序不可变
                  userId:sessionStorage.getItem('userId'),
                  userType:sessionStorage.getItem('type'),
                  projectIdAll:'',
                  detailVisible:false,
                  chooseObj:{
                      name:'',
                      n00005:'',
                      n00004:'',
                      lnglat:['',''],
                      point:""
                  },
                  picCount:0,
                  picUrl:'',
                  picUrlList:[],
                  calendarvalue:'',
                  dayType:'n00004',
                  mapData:new Map(),
                  clickFirst:true,
                  dialogCal:{
                      status1:0,
                      status2:0,
                      status3:0,
                  },
                  yestoday:'',
                  charts:null,
                  defaultProps:{
					multiple: true,
					children: "children",
          			label: "name",
					value:"projectId"
				},
                projectTree:[]
              }
          },
          methods: {
            clickBtn(type){
				if(type=="query"){
					this.getAllData(1);
				}else if(type=="reset"){
					this.reset();
				}
			},
            refreshMap(){
                this.map.setFitView();
            },
            showForm(){
                this.getProjectsTree();
                document.getElementById("indexForm").style.display="block";
                document.getElementsByClassName("showFormBtn")[0].style.display="none";
                document.getElementsByClassName("hideFormBtn")[0].style.display="block";
            },
            hideForm(){
                document.getElementById("indexForm").style.display="none";
                document.getElementsByClassName("showFormBtn")[0].style.display="block";
                document.getElementsByClassName("hideFormBtn")[0].style.display="none";
            },
            reset(){
                this.filters.projectId="";
                this.filters.functionalAreaId="";
            },
              //绑定按钮事件
            showNight:function(e) {
                this.factor="n00005";
                this.factorStr="夜间",
                this.statusDataChoose=this.statusData.night;
                document.getElementById("mapDataType").getElementsByTagName("button")[0].classList.remove("selected");
                e.srcElement.classList.add("selected");
                this.initMarker();
            },//夜数据
            showDay(e) {
                this.factor="n00004";
                this.factorStr="昼间",
                this.statusDataChoose=this.statusData.day;
                document.getElementById("mapDataType").getElementsByTagName("button")[1].classList.remove("selected");
                e.srcElement.classList.add("selected");
                this.initMarker();
            },//昼数据  
            //点击右侧栏
            chooseMarker(row){
                var m3 = new AMap.Marker({
                    position: [row.lnglat[0], row.lnglat[1]],
                });
                this.map.setFitView([m3]);
            },
              initMarker(){  
                  this.map.setStatus({zoomEnable:true});
                  this.map.clearMap();
                  //对获取到的设备进行展示
                  this.devices.forEach(item => {
                          var onjNum=item[this.factor];
                          if(onjNum==null){
                              onjNum="-";
                          }
                          var status="";
                          if(this.factor=="n00004"){
                              status=item.dayState;
                          }else{
                              status=item.nightState;
                          }
                          if(status==undefined){
                              status=3;
                          }
                          //创建标注
                          var marker = new AMap.Marker({
                              position:new AMap.LngLat(item.lnglat[0],item.lnglat[1]),
                              content:  '<div class="markSty" style="background:url(/static/'+this.statusMap.get(status)+'.png)">' +
                                  ' <span class="labelName">'+onjNum+'</span></div>',
                              extData:item
                          });
                          // 设置鼠标划过点标记显示的文字提示
                          marker.setTitle(item.point);
  
                          //将标注放大地图上
                          this.map.add(marker);
                          this.addClickHandler(marker);
                  });

                  //设置地图模式
                  if(this.factor=="n00004"){
                        this.map.setMapStyle("amap://styles/normal");
                  }else{
                        this.map.setMapStyle("amap://styles/dark");
                  }
              },
              //设备点击事件
              addClickHandler:function(target){
                  var _this=this;
                  target.on('click', function(e) {
                    _this.calendarvalue=new Date();
                    _this.calendarvalue=formatDateDay(_this.calendarvalue);

                    var obj=JSON.parse(JSON.stringify(e.target.getExtData()));
                    _this.chooseObj=obj;
                    _this.detailVisible=true;
                    _this.getPic();
                    _this.getDayData();
                    _this.selectNoiseTrend();
                    if(_this.clickFirst){
                        _this.initCalendar();
                        _this.clickFirst=false;
                    }
                  })
              },
              getPic(){
                let para = {
                    deviceId: this.chooseObj.deviceId
                };
                getDevicePic(para).then((res) => {

                    var fileListShow=  res.data.data;
                    this.picCount= res.data.data.length;
                    this.picUrlList=[];
                    fileListShow.forEach(element => {
                        var url=window.configuration.resourceUrlPhoto+element.urlName;
                        this.picUrlList.push(url);
                    });

                    if(fileListShow.length>0){
                        this.picUrl=this.picUrlList[0];
                    }
                });
              },
              getDayData(){
                this.calendarvalue=formatDate(this.calendarvalue);
                var arr=this.calendarvalue.split('-');
                var starttime=arr[0]+"-"+arr[1];

                let para = {
                    mn: this.chooseObj.mn,
                    date: starttime
                };
                this.listLoading = true;
                //数据格式处理
				selectNoiseCalendar(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.result==true||res.data.result=="true"){
                        var datas = res.data.datas;
                        let keys = Object.keys(datas);

                        this.mapData=new Map();
                        this.dialogCal.status1=0;
                        this.dialogCal.status2=0;
                        this.dialogCal.status3=0;
                        for (let index = 0; index < keys.length; index++) {
                            const element = keys[index];
                            var value=datas[element];
                            var color="#838b8b";
                            if(value!=null){
                                if(this.dayType=="n00004"){
                                    var n00004=value.n00004;
                                    if(n00004>this.chooseObj.day){
                                        color="#daa520";
                                        this.dialogCal.status2++;
                                    }else{
                                        color="#228b22";
                                        this.dialogCal.status1++;
                                    }
                                }else{
                                    var n00005=value.n00005;
                                    if(n00005>this.chooseObj.night){
                                        color="#daa520";
                                        this.dialogCal.status2++;
                                    }else{
                                        color="#228b22";
                                        this.dialogCal.status1++;
                                    }
                                }
                                this.mapData.set(element,color);
                            }else{
                                //判断是否为未来时间
                                var now = new Date();
                                var d1 = new Date(element);
                                var days=parseInt(now - d1) / 1000 / 3600 / 24 ;//天
                                if(days>2){
                                    this.mapData.set(element,color);
                                    this.dialogCal.status3++;
                                }
                            }
                        }
                    }else{
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }
				});
              },
              selectNoiseTrend(){
                let para = {
                    mn: this.chooseObj.mn,
                    date: this.yestoday
                };
                this.listLoading = true;
                //数据格式处理
				selectNoiseTrend(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.result==true||res.data.result=="true"){
                        var datas = res.data.datas;

                        var timeData=datas.dateTimeList;
                        var leqData=datas.leqList;

                        var diurnalInitialTime=datas.diurnalInitialTime;//6
                        var nightInitialTime=datas.nightInitialTime;//22

                        if(nightInitialTime==0){
                            nightInitialTime=24;
                        }

                        var xdata=[];
                        var ydata=[];
                        for (let index = 0; index < timeData.length; index++) {
                            const element = timeData[index];
                            var value=leqData[index];
                            var hour=element.split(" ")[1].split(":")[0];//获取小时
                           
                            xdata.push(hour);
                            if(value!=null){
                                var color="";
                                hour=parseInt(hour);
                                if(hour>diurnalInitialTime&&hour<=nightInitialTime){
                                    if(value>this.chooseObj.day){
                                        color="#daa520";
                                    }else{
                                        color="#228b22";
                                    }
                                }else{
                                    if(value>this.chooseObj.night){
                                        color="#daa520";
                                    }else{
                                        color="#228b22";
                                    }
                                }
                                var obj={
                                    value: value,
                                    itemStyle: {
                                        color: color
                                    }
                                }
                                ydata.push(obj);
                            }else{
                                ydata.push("-");
                            }
                        }

                        var markLineObj={
                            data: [
                                { yAxis: this.chooseObj.night, name: '夜间限值' },
                                { yAxis: this.chooseObj.day, name: '昼间限值'  }
                            ],
                            label: {
                                color: "#daa520"
                            },
                            lineStyle: {
                                color: "#daa520"
                            }
                        } 
                        this.initChart(xdata,ydata,markLineObj);
                    }else{
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }
				});
              },
              initChart(xdata,ydata,markLineObj){
                this.charts = echarts.init(document.getElementById("trendChart"));
                let option = {
                    color: ['#59a869'],
                    title: { text:this.title},
                    tooltip: { trigger: 'axis' },
                    xAxis: { data: xdata, name:'时间',},
                    yAxis:  { type: 'value', name:'噪声值(dB)'},
                    grid: {
                        left: '10%',
                        right: '10%',
                        bottom: '5%',
                        top:40,
                        containLabel: true
                    },
                    series:  {  
                        type: 'bar',data: ydata,
                        markLine: markLineObj
                    }
                }
                this.charts.setOption(option);
              },
              initCalendar(){
                this.$nextTick(() => {
                    // 点击上个月
                    let prevBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(1)');
                    prevBtn.addEventListener('click', () => {
                        this.calendarvalue=formatDateDay(this.calendarvalue);
                        this.getDayData();
                    })
                    // 点击今天
                    let currBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(2)');
                    currBtn.addEventListener('click', () => {
                        this.calendarvalue=formatDateDay(this.calendarvalue);
                        this.getDayData();
                    })
                    // 点击下个月
                    let nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)');
                    nextBtn.addEventListener('click', () => {
                        this.calendarvalue=formatDateDay(this.calendarvalue);
                        this.getDayData();
                    })
                })
              },
              //对地图进行渲染
              renderMap(){
                if(this.map==null){
                    // 创建Map实例
                    this.map = new AMap.Map("IndexPage", {
                        resizeEnable: true
                    });
                }
                this.initMarker();
                // 自适应显示多个点标记
                this.map.setFitView();
                this.firstFlag=false;
              },
            //查询项目信息
			getProjectsTree() {
                if(this.projectTree.length>0){
                    return;
                }
				//转树
                this.projectTree=translateDataToTreeProject(this.projects);
			},
             //查询项目信息
             getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.listLoading = false;
                    this.projects = res.data.data;
                    for (let index = 0; index < this.projects.length; index++) {
                        const element = this.projects[index];
                        this.projectMap.set(element.projectId,element.name);
                    }

                    if(this.userId==null||this.userId==""){
                        var _this=this;
                        var timer;
                        clearInterval(timer);
                        timer=setInterval(() => {
                            _this.userId=sessionStorage.getItem("userId");
                            if(_this.userId!=null&&_this.userId!=""){
                                clearInterval(timer);
                                _this.getAllData(0);
                            }
                        }, 100);
                    }else{
                        this.getAllData(0);
                    }
				});
			},
            getAllData(flag){
                if(flag==0){
                    this.userType=sessionStorage.getItem('type');

                    if(this.userType=="0"&&this.projects.length>5){
                        if(this.projects.length>0){
                            this.filters.projectId=this.projects[0].projectId;
                        }
                    }
                    this.projectIdAll= this.projects.map(item => item.projectId).toString();
                }

				var start = new Date(this.date);//2月12日 就是2.12/06:00--2.13/06:00 包前不包后
				start.setTime(start.setHours(6));
                start.setTime(start.setMinutes(0));
                start.setTime(start.setSeconds(0));

                var end = new Date(start);
                end.setTime(end.setDate(end.getDate()+1));
                end.setTime(end.setHours(5));

                var startTime=formatDate(start);
                var endTime=formatDate(end);

                this.selectHourDataList(startTime,endTime);
                this.selectDayDataList(startTime,endTime);
                if(this.userId==null){
                    var _this=this;
                    var timer;
                    clearInterval(timer);
                    timer=setInterval(() => {
                        _this.userId=sessionStorage.getItem("userId");
                        if(_this.userId!=null){
                            clearInterval(timer);
                            _this.getComplianceRate(startTime,endTime);
                        }
                    }, 1000);
                }else{
                    this.getComplianceRate(startTime,endTime);
                }
            },
            selectHourDataList(startTime,endTime){
                let para={
                    functionalAreaId:this.filters.functionalAreaId,
                    startTime:startTime,
                    endTime: endTime
                }
                if(this.filters.projectId!=""){
                    para.projectId=this.filters.projectId.toString()
                }else{
                    para.projectId=this.projectIdAll;
                }
                selectHourDataList(para).then((res) => {
                    this.hourRate=parseFloat(res.data.onlineRate);
                    this.distributionStatisticsyData=res.data.statistics;
                    this.rateReviewData=[
                        {value: res.data.Unaudited, name: '未审核'},
                        {value: res.data.abnormal, name: '无效'},
                        {value: res.data.pass, name: '通过'}
                    ]
                }).catch(err => {
                    console.log(err)
                    this.$message({
                        message: "操作失败，请重试",
                        type: 'error'
                    });
                })
            },
            selectDayDataList(startTime,endTime){
                let para={
                    functionalAreaId:this.filters.functionalAreaId,
                    startTime:startTime,
                    endTime: endTime
                }
                if(this.filters.projectId!=""){
                    para.projectId=this.filters.projectId.toString()
                }else{
                    para.projectId=this.projectIdAll;
                }
                selectDayDataList(para).then((res) => {
                    this.functionalAreaList=res.data.functionAlarea;
                    this.devices=res.data.data;
                    this.renderMap();
                   
                    this.statusData={
                      day:{
                        status1:res.data.daynormal,
                        status2:res.data.dayexceed,
                        status3:res.data.dayuseless,
                        rate:res.data.dayrate,
                      },
                      night:{
                        status1:res.data.nightnormal,
                        status2:res.data.nightexceed,
                        status3:res.data.nightuseless,
                        rate:res.data.nightrate,
                      }
                    }
                    if(this.factor=="n00004"){
                        this.statusDataChoose=this.statusData.day;
                    }else{
                        this.statusDataChoose=this.statusData.night;
                    }
                   
                }).catch(err => {
                    this.$message({
                        message: "操作失败，请重试",
                        type: 'error'
                    });
                })
            },
            getComplianceRate(startTime,endTime){
				let para = {
                    userId:this.userId,
					startDate: startTime,
                    endDate: endTime
				};
                if(this.filters.projectId!=""){
                    para.projectId=this.filters.projectId.toString()
                }else{
                    para.projectId=this.projectIdAll;
                }
                if(this.filters.functionalAreaId!=""){
					para.functionalAreaId=this.filters.functionalAreaId;
				}
				this.listLoading = true;
                getComplianceRate(para).then((res) => { 
                    this.listLoading = false;
                    if(res.data.result==false){
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }else{
                        this.dataList = res.data.data; 

                        var xdata=[];
                        var dayData=[];
                        var nightData=[];

                        this.dataList.forEach(element => {
                            xdata.push(element.functionalAreaName);
                            dayData.push(element.dayRate);
                            nightData.push(element.nightRate);
                        });
                        this.rateStaticData={
                            xdata:xdata,
                            dayData:dayData,
                            nightData:nightData
                        }
                    }
                });
            },
              changeMapSize(){
                   // 只关心高度 电脑高度734 地图高度610
                  var value=734-610+60;
                  var valueW=1080-946-50;
                  var winHeight=document.body.clientHeight-value;
                  var winWidth=document.body.clientWidth-valueW;
  
                  if(document.getElementById("IndexPage")!=null){
                      document.getElementById("IndexPage").style.height=winHeight+"px";
                      document.getElementById("IndexPage").style.width=winWidth+"px";
                  }

                  this.tableHeight=winHeight*0.25;
              },
              showTable(){
                if(this.tableShow){
                    this.tableShow=false;
                    document.getElementById("mapDialog").style.display="none";
                    document.getElementById("indexToggleBtn").style.backgroundPositionY="0";
                }else{
                    this.tableShow=true;
                    document.getElementById("mapDialog").style.display="block";
                     document.getElementById("indexToggleBtn").style.backgroundPositionY="-32px";
                }
            },
          },
          mounted() {
            this.statusMap.set(1,'228b22');//正常
            this.statusMap.set(2,'daa520');//超标
            this.statusMap.set(3,'838b8b');//无数据

            var start = new Date();//2月12日 就是2.12/06:00--2.13/06:00 包前不包后
            start.setTime(start.setDate(start.getDate()-1));//昨天
            this.date=formatDateDay(start);
            this.yestoday=formatDateDay(start);

            this.getProjects();

            this.changeMapSize();

            //窗口大小改变时
            var _this=this;
            window.onresize = function(){
                _this.changeMapSize();
            }
          }
      }
  </script>
  <style>
      html,body{
          width: 100%;
          height: 100%;
          overflow: hidden;
          margin: 0;
          font-family: "微软雅黑";
      }  

      #IndexPage{
        height: 610px;
    }

      #indexForm{
        position: absolute;
        top: -20px;
        left: 0;
        z-index: 999;
        background: #fff;
        padding: 20px;
        width: 100%;
        height: 100px;
        display: none;
      }
      .showFormBtn{
          display: block;
      }
      .hideFormBtn{
          display: none;
      }

      #indexToggleBtn{
        background: url(/static/blueArrows.png) 0 -32px no-repeat;
        cursor: pointer;
        width: 32px;
        height: 32px;
        opacity: 0.6;
        filter: alpha(opacity=60);
        display: block;
        background-size: 200% 200%;
        position: fixed;
        right:-6px;
        top:45%;
    }

      #IndexPage .labelName{
          color: #fff;
      }
      #mapDialog{
        padding: 20px;
        display: block;
        height: 100%;
      }
      #indexMapLeft,#indexMapRight{
        width: 22%;
        height: calc(100% - 70px);
        border-radius: 6px;
        position: absolute;
        z-index: 999;
        background-color: #fff;
      }

      #indexMapRight{
        right: 40px;
      }

      .mapFun{
        width: 350PX;
        position: absolute;
        right: 25%;
        bottom: 30px;
        z-index: 999;
        background: #fff;
        padding: 8px;
        border-radius: 5px;
      }
      .mapFun .cyedbs_name {
        text-align: center;
        font-size: 15px;
        color: #777;
        font-weight: 600;
    }
    .mapFun .cyedbs_size {
        padding-top: 10px;
    }
    .mapFun .cyedbs_size .nbmrd_name {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
        color: #666;
        text-align: center;
        border: 1px solid #d8dfe6;
    }

    #mapDataType{
        position: absolute;
        right: 25%;
        bottom: 150px;
        z-index: 999;
    }

    .indexTitle{
        color: #666;
        font-size: 18px;
        font-weight: 700;
        margin-left: 10px;
        margin-right: 10px;
        padding-bottom: 10px;
        padding-top: 10px;
        display: -webkit-box;
        display: -ms-flexbox;
        -webkit-box-align: center;
        -ms-flex-align: center;
        border-bottom: 1px solid rgba(9,9,9,.1);
        display: flex;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
    }

    .unes_unoe{
        padding: 20px 10px;
    }
    .unes_unoe .unes_we, .unes_unoe {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
    }
    .unes_unoe .unes_we {
        width: 100px;
        height: 30px;
        background-color: #f1f1f1;
        border-radius: 6px;
    }
    .unes_unoe .unes_we .une_text {
        font-size: 14px;
        width: 50%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
    .unes_unoe .unes_we .IEM_w {
        width: 50%;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        border-radius: 0 6px 6px 0;
        color: #fff;
    }
    .unes_unoe .unes_we .col_1 {
        background: #228b22;
    }
    .unes_unoe .unes_we .col_2 {
        background: #daa520;
    }
    .unes_unoe .unes_we .col_3 {
        background: #838b8b;
    }
    .unes_unoe .unes_we .col_4 {
        background: red;
    }

    .indexdisSta,.indexhourData{
        width: 100%;
        height: 33%;
    }

    #indexMapLeft .indexdisSta{
        height: 42%;
    }
    #indexMapLeft .indexhourData{
        height: 42%;
    }


    .index_cal{
        border-radius: 10px;
        padding: 3px 0;
    }
      .anchorBL {  
          display: none;  
      } 
      .input-card .selected{
          color:white;
          background: #25A5F7;
      }
      .markSty{
          position: relative;
          width: 36px;
          height: 30px;
          line-height: 30px;
          text-align: center;
      }
      .markSty span{
          position: relative;
          bottom: 3px;
      }
      #indexToggleBtn{
          background: url(/static/blueArrows.png) 0 0 no-repeat;
          cursor: pointer;
          width: 32px;
          height: 32px;
          opacity: 0.6;
          filter: alpha(opacity=60);
          display: block;
          background-size: 200% 200%;
          position: fixed;
          right:-6px;
          top:45%;
      }
      #deviceTable{
          display: none;
          width:16%;
          float:left;
          margin-left:2%;
      }
  
      #realUl{
          font-size:14px;
          overflow:hidden;
          width:500px;
          margin-top:10px;
      }
      #realUl li{
          list-style:none;
          float: left;
          min-width: 150px;
          min-height: 22px;
      }
  
      #fac{
          width: 30%;
          overflow-y: scroll;
      }
      .amap-marker-label{
          display: block;
          border: none;
          background-color: transparent;
      }
  
    .map .el-calendar__body{
        padding-bottom: 0;
    }
      .map  .el-calendar-table .el-calendar-day {
        height: 40px;
      }
  </style>


// WEBPACK FOOTER //
// indexPage.vue?6c75657c